export interface SpecialEventResponse {
  id_evento:           number;
  Fecha:               string;
  nombre_evento:       string;
  tipo_evento:         string;
  fecha_hora_creacion: string;
  "Creado Por":        string;
}

export interface CreateSpecialEventBody {
  sucursal?: number;
  fecha_inicio: string;  // formato DD/MM/YYYY
  fecha_fin: string;     // formato DD/MM/YYYY
  nombre: string;
  tipo: "Personalizado" | "Predeterminado";
  creado_por: number;
}

export interface EditSpecialEventBody {
  sucursal?: number;
  id: number;
  fecha_inicio: string;  // formato DD/MM/YYYY
  fecha_fin: string;     // formato DD/MM/YYYY
  nombre: string;
  tipo: "Personalizado" | "Predeterminado";
  creado_por: number;
}

export interface SpecialEventRenamed {
  id_evento:           number;
  Fecha:               string;
  Nombre:       string;       // Antes nombre_evento
  Tipo:         string;           // Antes tipo_evento
  fecha_hora_creacion: string;
  "Creado Por":        string;
}
